import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CycleCalendarWrapper } from './styles';
import CycleRow from '../../components/CycleRow';
import CycleHeader from '../../components/CycleHeader';

const customRaces = ['7101', '90014'];

class CycleCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }
  componentDidMount() {
    this.resizeCallback();
    const { sportId, competitionId, seasonId } = window.matchcenterPage;
    this.props.actions.getCycleCalendar(sportId, competitionId, seasonId);
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: process.env.REACT_APP_SITE === 'gazzetta' ? window.innerWidth <= 1023 : window.innerWidth <= 767,
    });
  };

  render() {
    const { isMobile } = this.state;
    const { dictionary, cycleCalendar } = this.props;
    const { competitionId } = window.matchcenterPage;
    const isCustomRace = customRaces.includes(competitionId.toString());
    return (
      <CycleCalendarWrapper>
        {cycleCalendar.size > 0 &&
        <CycleHeader
          isMobile={isMobile}
          isCustomRace={isCustomRace}
        />
        }
        {
          cycleCalendar.size > 0 && cycleCalendar.get('races').size > 0 &&
          cycleCalendar.get('races').map((stage, index) => (
            <CycleRow
              cycleStage={stage}
              key={index}
              tappa={index + 1}
              dictionary={dictionary}
              isMobile={isMobile}
              isCustomRace={isCustomRace}
            />
          ))
        }
      </CycleCalendarWrapper>
    );
  }
}

CycleCalendar.propTypes = {
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  cycleCalendar: PropTypes.any,
};

export default CycleCalendar;



// WEBPACK FOOTER //
// ./src/containers/CycleCalendar/index.js